import {
  FETCH_COMMENTS,
  UPDATE_ADD_COMMENT_ERROR,
  UPDATE_ADD_REPLY_ERROR,
  UPDATE_ADD_REPLY_ID,
  UPDATE_ANON_USER_NAME,
  UPDATE_COMMENTS,
  UPDATE_COMMENTS_TIMESTAMP,
  UPDATE_COMMENTS_TIMESTAMP_FROZEN,
  UPDATE_COMMENT_BUCKETS,
  UPDATE_COMMENT_REPLY_COUNT,
  UPDATE_EXPANDED_REPLY_IDS,
  UPDATE_FETCHING_COMMENTS_ERROR,
  UPDATE_IN_GUEST_FLOW,
  UPDATE_IN_GUEST_FLOW_REPLY,
  UPDATE_IS_FETCHING,
  UPDATE_VIDEO_PLAYER_CURRENT_TIME,
} from 'constants/actions';

const DEFAULT_STATE = {
  add_reply_id: null,
  anon_user_name: '',
  comment_buckets: {},
  comments: [],
  comment_reply_count: null,
  error_fetching: null,
  error_add_comment: null,
  error_add_reply: null,
  enabled: false,
  expanded_ids: [],
  in_guest_flow: false,
  in_guest_flow_reply: false,
  time_stamp_frozen: false,
  has_fetched: false,
  is_fetching: false,
  time_stamp: 0,
};

const commentsReducer = (state = DEFAULT_STATE, action) => {
  switch (action.type) {
    case FETCH_COMMENTS:
      return {
        ...state,
        error_fetching: DEFAULT_STATE.error_fetching,
        has_fetched: false,
        is_fetching: true,
      };
    case UPDATE_ADD_COMMENT_ERROR:
      return {
        ...state,
        error_add_comment: action.err,
      };
    case UPDATE_ADD_REPLY_ERROR:
      return {
        ...state,
        error_add_reply: action.err,
      };
    case UPDATE_ADD_REPLY_ID:
      return {
        ...state,
        add_reply_id: action.addReplyId,
      };
    case UPDATE_ANON_USER_NAME:
      return {
        ...state,
        anon_user_name: action.anonUserName,
      };
    case UPDATE_COMMENT_BUCKETS:
      return {
        ...state,
        comment_buckets: action.commentBuckets,
      };
    case UPDATE_COMMENT_REPLY_COUNT:
      return {
        ...state,
        comment_reply_count: action.commentReplyCount,
      };
    case UPDATE_COMMENTS:
      return {
        ...state,
        comments: action.comments,
        has_fetched: true,
        is_fetching: false,
      };
    case UPDATE_VIDEO_PLAYER_CURRENT_TIME:
    case UPDATE_COMMENTS_TIMESTAMP:
      return {
        ...state,
        time_stamp: Math.floor(action.timestamp || action.current_time || 0),
      };
    case UPDATE_COMMENTS_TIMESTAMP_FROZEN:
      return {
        ...state,
        time_stamp_frozen: action.frozen,
      };
    case UPDATE_EXPANDED_REPLY_IDS:
      return {
        ...state,
        expanded_ids: action.expandedIds,
      };
    case UPDATE_FETCHING_COMMENTS_ERROR:
      return {
        ...state,
        error_fetching: action.fetchingError,
        has_fetched: true,
        is_fetching: false,
      };
    case UPDATE_IN_GUEST_FLOW:
      return {
        ...state,
        in_guest_flow: action.inGuestFlow,
      };
    case UPDATE_IN_GUEST_FLOW_REPLY:
      return {
        ...state,
        in_guest_flow_reply: action.inGuestFlowReply,
      };
    case UPDATE_IS_FETCHING:
      return {
        ...state,
        is_fetching: action.isFetching,
      };
    default:
      return state;
  }
};

export default commentsReducer;
